import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { TransactionEffects } from './transaction.effects';
import { ITransactionFeature } from './transaction.feature.state';
import { transactionReducer } from './transaction.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ITransactionFeature>('transactionFeature'), transactionReducer),
    EffectsModule.forFeature([TransactionEffects]),
  ],
})
export class TransactionStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: TransactionStateModule
  ) {
    if (parentModule) {
      throw new Error('TransactionStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
